import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { PREFIX_FRONT_URL } from '../consts';
import LandingComponent from './LandingComponent';
import ExchangeContainer from '../containers/ExchangeContainer';
import LoginContainer from '../containers/LoginContainer';
import VerifyEmailContainer from '../containers/VerifyEmailContainer';
import UserInfoContainer from '../containers/UserInfoContainer';
import WalletContainer from '../containers/WalletContainer';
import VerifyWithdrawalContainer from '../containers/VerifyWithdrawalContainer';
import MarketContainer from '../containers/MarketContainer';
import QuestionAnswer from './question_answer/QuestionAnswer';
import notifyAction from '../redux/actions/notify';
import ExchangeSelect from './exchange/ExchangeSelect';
import GuideComponent from './GuideComponent';
import ReferralWithLoginComponent from './ReferralWithLoginComponent';
import ReferralWithoutLoginComponent from './ReferralWithoutLoginComponent';
import NotificationPageContainer from '../containers/NotificationPageContainer';
import PageCampaignContainer from '../containers/PageCampaignContainer';
function PrivateComponent(Component, isAuthenticated = false) {
  return isAuthenticated ? Component : <Redirect to={`${PREFIX_FRONT_URL}/${window.c.routes.LOGIN}`} />;
}

function PublicComponent(Component, isAuthenticated = false) {
  return isAuthenticated ? <Redirect to={`${PREFIX_FRONT_URL}/`} /> : Component;
}

class AppRouterComponent extends Component {
  render() {
    const { isAuthenticated, logout } = this.props;

    return (
      <Switch>
        <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.HOME}`} key={`route_${window.c.routes.HOME}`}>
          <LandingComponent />
        </Route>
        <Route exact path={`${PREFIX_FRONT_URL}/`} key={`route_${window.c.routes.ROOT}`}>
          <ExchangeContainer logout={logout} />
        </Route>
        <Route exact path={`${PREFIX_FRONT_URL}/market`} key={`route_${window.c.routes.MARKET}`}>
          <MarketContainer isLandingPage />
        </Route>
        <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.LOGIN}`} key={`route_${window.c.routes.LOGIN}`}>
          {PublicComponent(<LoginContainer />, isAuthenticated)}
        </Route>
        <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.VERIFY}`} key={`route_${window.c.routes.VERIFY}`}>
          <div className="mt-medium" />
          <VerifyEmailContainer />
        </Route>
        <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.USER_INFO}`} key={`route_${window.c.routes.USER_INFO}`}>
          <div className="mt-medium" />
          <UserInfoContainer />
        </Route>
        <Route path={`${PREFIX_FRONT_URL}/${window.c.routes.FAQS}`} key={`route_${window.c.routes.FAQS}`}>
          <Router>
            <QuestionAnswer />
          </Router>
        </Route>
        <Route path={`${PREFIX_FRONT_URL}/${window.c.routes.USER_WALLET}`} key={`route_${window.c.routes.USER_WALLET}`}>
          {PrivateComponent(<WalletContainer />, isAuthenticated)}
        </Route>
        <Route path={`${PREFIX_FRONT_URL}/${window.c.routes.VERIFY_WITHDRAW}`} key={`route_${window.c.routes.VERIFY_WITHDRAW}`}>
          <VerifyWithdrawalContainer />
        </Route>
        <Route path={`${PREFIX_FRONT_URL}/${window.c.routes.GUIDE}`} key={`route_${window.c.routes.GUIDE}`}>
          <GuideComponent />
        </Route>
        <Route path={`${PREFIX_FRONT_URL}/${window.c.routes.REFERRAL}`} key={`route_${window.c.routes.REFERRAL}`}>
          <ReferralWithoutLoginComponent />
          {/*{isAuthenticated ? <ReferralWithLoginComponent /> : <ReferralWithoutLoginComponent />}*/}
        </Route>
        <Route path={`${PREFIX_FRONT_URL}/${window.c.routes.PAGECAMPAIGN}`} key={`route_${window.c.routes.PAGECAMPAIGN}`}>
          <PageCampaignContainer />
        </Route>
        <Route path={`${PREFIX_FRONT_URL}/${window.c.routes.NOTIFICATION}`} key={`route_${window.c.routes.NOTIFICATION}`}>
          {PrivateComponent(<NotificationPageContainer />, isAuthenticated)}
        </Route>
      </Switch>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
});

export default connect(mapStateToProps, null)(AppRouterComponent);
